/**
 * Page that receives the login token(s) via the URL and initiates the process
 * of setting the user's session
 */
import React from 'react';
import PropTypes from 'prop-types';

import LoadingPlaceholder from '../LoadingPlaceholder/LoadingPlaceholder';

const propTypes = {
  setSessionHandler: PropTypes.func.isRequired,
  originatingURL: PropTypes.string,
  location: PropTypes.shape({
    hash: PropTypes.string,
  }).isRequired,
};

const defaultProps = {
  originatingURL: null,
};

class SessionLoaderPage extends React.Component {
  componentDidMount() {
    const { location, originatingURL, setSessionHandler } = this.props;
    setSessionHandler(location, originatingURL);
  }

  render() {
    return <LoadingPlaceholder />;
  }
}

SessionLoaderPage.propTypes = propTypes;
SessionLoaderPage.defaultProps = defaultProps;

export default SessionLoaderPage;
